import BaseException from '../base_exception'

class ErrorUpload extends BaseException {
  constructor(message = '') {
    super(message)
  }
}

export default ErrorUpload
